// extracted by mini-css-extract-plugin
export default {"flex-center":"aside_flex-center__KKBJJ","flex-vertical-center":"aside_flex-vertical-center__GXYY-","aside":"aside_aside__Xn9Z9"};